// @noflow
import React, { Component } from 'react';

// Replacement for a `div` that needs to stop browser gestures like Chrome's
// "swipe to go back". It passes through all `props` and it's up to the consumer
// to make sure all of them are suitable for a `div`.

export default class PreventBackGesture extends Component {
    handleWheel = e => {
        if (this.root.scrollLeft + e.deltaX < 0) {
            e.preventDefault();
        }
    };

    render() {
        return <div {...this.props} onWheel={this.handleWheel} ref={c => (this.root = c)} />;
    }
}



// WEBPACK FOOTER //
// ./src/components/widgets/prevent-back-gesture/index.js